var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as lodash from '../../utils/lodash';
import { ComponentModel } from '../../model';
import { Group } from '../../element';
import Zoomable from '../../element/zoomable';
import { registerComponent } from '../index';
import normalizeToArray from '../../utils/normalizeToArray';
function matchKey(proxyEvent, key) {
    if (!proxyEvent) {
        return true;
    }
    var event = proxyEvent.original;
    if (!key) {
        return true;
    }
    if (event.shiftKey) {
        return key === 'shift';
    }
    if (event.ctrlKey) {
        return key === 'ctrl';
    }
    if (event.altKey) {
        return key === 'alt';
    }
}
/**
 * zoom class
 */
var DataZoom = /** @class */ (function (_super) {
    __extends(DataZoom, _super);
    function DataZoom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataZoom';
        _this._iszooming = false;
        _this.handlePlotDragStart = function () {
            // this.chart.setInteraction(true);
        };
        _this.handlePlotDragEnd = function () {
            // this.chart.setInteraction(false);
        };
        _this.handlePlotDrag = function (event) {
            if (_this._iszooming) {
                return;
            }
            var _a = event.mouse, dx = _a.dx, dy = _a.dy, original = _a.original;
            if (_this.option.length && original && original.preventDefault) {
                original.preventDefault();
            }
            _this.option.forEach(function (zoomOption) {
                var axis = zoomOption.axis, panKey = zoomOption.panKey, panning = zoomOption.panning;
                var brushOption = _this.chart.getOption().brush;
                if (matchKey(event.mouse, panKey) && panning && !(brushOption && brushOption.enabled)) {
                    _this.panAxis(axis, {
                        dx: -dx,
                        dy: -dy,
                    });
                }
            });
        };
        _this.refreshChart = function () {
            _this.chart.dispatchAction({
                type: 'zoom',
            });
            _this.chart.refresh();
        };
        _this.handleZooming = function (event) {
            var grid = _this.chart.getComponentModel('coord').grid;
            var origin = event.origin, zoom = event.zoom;
            var x = origin[0], y = origin[1];
            _this.option.forEach(function (zoomOption) {
                var axis = zoomOption.axis, panOnMouseWheel = zoomOption.panOnMouseWheel, zooming = zoomOption.zooming, zoomKey = zoomOption.zoomKey, panKey = zoomOption.panKey;
                var xAxisList = grid.xAxis;
                var yAxisList = grid.yAxis;
                if (matchKey(event.mouse, zoomKey) && zooming && !panOnMouseWheel) {
                    if (axis === 'x' || axis === 'xy') {
                        xAxisList.forEach(function (xAxis) {
                            var originX = xAxis.scale.invert(x);
                            var _a = xAxis.getSliderExtreme(), min = _a[0], max = _a[1];
                            var _b = xAxis.getExtreme(true), dataMin = _b[0], dataMax = _b[1];
                            var zoomMin = (min - originX) / zoom + originX;
                            var zoomMax = (max - originX) / zoom + originX;
                            var range = [
                                lodash.clamp(zoomMin, dataMin, dataMax),
                                lodash.clamp(zoomMax, dataMin, dataMax),
                            ];
                            xAxis.option.min = lodash.min(range);
                            xAxis.option.max = lodash.max(range);
                        });
                    }
                    if (axis === 'y' || axis === 'xy') {
                        yAxisList.forEach(function (yAxis) {
                            var originY = yAxis.scale.invert(y);
                            var _a = yAxis.getSliderExtreme(), min = _a[0], max = _a[1];
                            var _b = yAxis.getExtreme(true), dataMin = _b[0], dataMax = _b[1];
                            var zoomMin = (min - originY) / zoom + originY;
                            var zoomMax = (max - originY) / zoom + originY;
                            var range = [
                                lodash.clamp(zoomMin, dataMin, dataMax),
                                lodash.clamp(zoomMax, dataMin, dataMax),
                            ];
                            yAxis.option.min = lodash.min(range);
                            yAxis.option.max = lodash.max(range);
                        });
                    }
                    _this.refreshChart();
                }
                if (panOnMouseWheel && matchKey(event.mouse, panKey)) {
                    if (!(event.mouse.type === 'wheel')) {
                        return;
                    }
                    var isTouchPad = event.mouse.original.wheelDelta % 40 !== 0;
                    var _a = event.mouse.normalizeWheel, pixelX = _a.pixelX, pixelY = _a.pixelY;
                    var dx = axis === 'x' || axis === 'xy' ? (axis === 'xy' || isTouchPad ? pixelX : pixelY) : 0;
                    var dy = axis === 'y' || axis === 'xy' ? pixelY : 0;
                    var toEnd = _this.panAxis(axis, {
                        dx: dx,
                        dy: dy,
                    });
                    if (!toEnd && event.mouse) {
                        event.mouse.original.preventDefault();
                    }
                }
            });
        };
        return _this;
    }
    DataZoom.prevProcessOption = function (option) {
        option.dataZoom = option.dataZoom || [];
    };
    DataZoom.prototype.getDefaultOption = function (option) {
        var defaultOption = {
            axis: 'x',
            zooming: true,
            panning: true,
            panOnMouseWheel: false,
            zoomKey: null,
            panKey: null,
            throttle: 100,
        };
        return normalizeToArray(option).map(function () { return lodash.merge({}, defaultOption); });
    };
    DataZoom.prototype.init = function () {
        this._refreshChart = this.refreshChart.bind(this);
        this.attachUIEvents();
        this._setThrottle();
    };
    DataZoom.prototype.attachUIEvents = function () {
        var _this = this;
        var plotArea = this.chart.getComponentModel('coord').grid.getEventPlotArea();
        this.registerEvent('plot:dragstart', this.handlePlotDragStart);
        this.registerEvent('plot:drag', this.handlePlotDrag);
        this.registerEvent('plot:dragend', this.handlePlotDragEnd);
        this._zoomController = new Zoomable(plotArea, {
            sensitivity: 1,
            preventDefault: false,
            onZoomStart: function () {
                _this._iszooming = true;
            },
            onZooming: this.handleZooming,
            onZoomEnd: function () {
                _this._iszooming = false;
            },
        });
    };
    DataZoom.prototype._setThrottle = function () {
        var _a;
        this.refreshChart = lodash.throttle(this._refreshChart, (_a = this.option[0]) === null || _a === void 0 ? void 0 : _a.throttle);
    };
    /**
     *
     * @return does the axis reach top or bottom
     */
    DataZoom.prototype.panAxis = function (axis, offset) {
        var grid = this.chart.getComponentModel('coord').grid;
        var xAxisList = grid.xAxis;
        var yAxisList = grid.yAxis;
        var dx = offset.dx, dy = offset.dy;
        var scrollToExtreme = false;
        if (axis === 'x' || axis === 'xy') {
            xAxisList.forEach(function (xAxis) {
                // const { left, right } = xAxis.getState();
                var _a = xAxis.getSliderExtreme(), min = _a[0], max = _a[1];
                var _b = xAxis.getExtreme(true), dataMin = _b[0], dataMax = _b[1];
                var pixelValue = xAxis.getPixelValue();
                var zoomMin = min + pixelValue * dx;
                var zoomMax = max + pixelValue * dx;
                if ((min <= dataMin && zoomMin <= dataMin) || (max >= dataMax && zoomMax >= dataMax)) {
                    scrollToExtreme = true;
                }
                if (zoomMax > dataMax) {
                    zoomMin = dataMax - (zoomMax - zoomMin);
                    zoomMax = dataMax;
                }
                if (zoomMin < dataMin) {
                    zoomMax = dataMin + (zoomMax - zoomMin);
                    zoomMin = dataMin;
                }
                xAxis.option.min = zoomMin;
                xAxis.option.max = zoomMax;
            });
        }
        if (axis === 'y' || axis === 'xy') {
            yAxisList.forEach(function (yAxis) {
                var _a = yAxis.getSliderExtreme(), min = _a[0], max = _a[1];
                var _b = yAxis.getExtreme(true), dataMin = _b[0], dataMax = _b[1];
                var pixelValue = yAxis.getPixelValue();
                var zoomMin = min + pixelValue * dy;
                var zoomMax = max + pixelValue * dy;
                if ((min <= dataMin && zoomMin <= dataMin) || (max >= dataMax && zoomMax >= dataMax)) {
                    scrollToExtreme = true;
                }
                if (zoomMax > dataMax) {
                    zoomMin = dataMax - (zoomMax - zoomMin);
                    zoomMax = dataMax;
                }
                if (zoomMin < dataMin) {
                    zoomMax = dataMin + (zoomMax - zoomMin);
                    zoomMin = dataMin;
                }
                yAxis.option.min = zoomMin;
                yAxis.option.max = zoomMax;
            });
        }
        this.refreshChart();
        return scrollToExtreme;
    };
    DataZoom.prototype.beforeRender = function () {
        if (this.option.length) {
            this._zoomController.enable();
        }
        else {
            this._zoomController.disable();
        }
    };
    DataZoom.prototype.updated = function () {
        this._zoomController.destroy();
        this.attachUIEvents();
        this._setThrottle();
    };
    DataZoom.prototype.beforeDestroy = function () {
        this._zoomController.destroy();
    };
    DataZoom.prototype.render = function () {
        return new Group({ key: this.getKey('dataZoom') });
    };
    return DataZoom;
}(ComponentModel));
export default DataZoom;
registerComponent('dataZoom', DataZoom);
